import type { FC } from "react";
import { cn } from "../../lib/utils";

export type ClassificationPendingSparkleProps = {
	className?: string;
	animated?: boolean;
};

export const ClassificationPendingSparkle: FC<ClassificationPendingSparkleProps> = ({
	className,
	animated = true,
}) => (
	<svg
		role="img"
		aria-label="Classifying document"
		data-testid="classification-pending-sparkle"
		className={cn("h-[18px] w-[18px] shrink-0", className)}
		width={18}
		height={18}
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g
			className={cn(
				"text-violet-400",
				animated && "animate-classification-sparkle motion-reduce:animate-none text-violet-600",
			)}
			style={{ transformBox: "fill-box" as const }}
		>
			<path
				d="M6.9557 11.9531L6.28846 14.2885L5.62122 11.9531C5.27076 10.7265 4.31195 9.7677 3.08533 9.41724L0.75 8.75L3.08534 8.08276C4.31195 7.7323 5.27076 6.77349 5.62122 5.54687L6.28846 3.21154L6.9557 5.54687C7.30616 6.77349 8.26498 7.7323 9.49159 8.08276L11.8269 8.75L9.49159 9.41724C8.26497 9.7677 7.30616 10.7265 6.9557 11.9531Z"
				fill="none"
				stroke="currentColor"
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<g
			className={cn(
				"text-violet-400",
				animated &&
					"animate-classification-sparkle motion-reduce:animate-none [animation-delay:180ms] text-violet-600",
			)}
			style={{ transformBox: "fill-box" as const }}
		>
			<path
				d="M13.8855 6.05424L13.6731 6.90385L13.4607 6.05424C13.2126 5.06206 12.4379 4.28737 11.4458 4.03933L10.5962 3.82692L11.4458 3.61452C12.4379 3.36648 13.2126 2.59178 13.4607 1.59961L13.6731 0.75L13.8855 1.59961C14.1335 2.59178 14.9082 3.36648 15.9004 3.61452L16.75 3.82692L15.9004 4.03933C14.9082 4.28737 14.1335 5.06206 13.8855 6.05424Z"
				fill="none"
				stroke="currentColor"
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<g
			className={cn(
				"text-violet-400",
				animated &&
					"animate-classification-sparkle motion-reduce:animate-none [animation-delay:360ms] text-violet-600",
			)}
			style={{ transformBox: "fill-box" as const }}
		>
			<path
				d="M12.7658 15.7796L12.4423 16.75L12.1188 15.7796C11.9351 15.2283 11.5025 14.7957 10.9512 14.6119L9.98077 14.2885L10.9512 13.965C11.5025 13.7812 11.9351 13.3486 12.1188 12.7974L12.4423 11.8269L12.7658 12.7974C12.9495 13.3486 13.3821 13.7812 13.9334 13.965L14.9038 14.2885L13.9334 14.6119C13.3821 14.7957 12.9495 15.2283 12.7658 15.7796Z"
				fill="none"
				stroke="currentColor"
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
